import { LOANS_MODAL_STATES } from 'loans.module/common/domain/constants.loans';

class ModalQuestionCadastralController {
  constructor() {
    this.modalStates = LOANS_MODAL_STATES;
  }

  getModalShow(modalToShow) {
    return this.optionIsSelected === modalToShow;
  }
}

export default ModalQuestionCadastralController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/myLoans/cadastralReferenceMobile/modalQuestionCadastral/modalQuestionCadastral.controller.js